import cs from "date-fns/locale/cs";
import { LocaleUtils } from "react-day-picker";
import { stringInputParseDate } from "./baseFormating";

export const csLocalizer: typeof LocaleUtils = {
    formatDay(day: Date, _?: string): string {
        return cs.localize.day(day);
    },
    formatMonthTitle(month: Date, _?: string): string {
        return cs.localize.month(month);
    },
    formatWeekdayLong(weekday: number, _?: string): string {
        return cs.localize.day(weekday);
    },
    formatWeekdayShort(weekday: number, _?: string): string {
        return cs.localize.day(weekday, {
            width: "short",
        });
    },
    getFirstDayOfWeek(_?: string): number {
        return cs.options.weekStartsOn;
    },
    getMonths(
        _?: string,
    ): [string, string, string, string, string, string, string, string, string, string, string, string] {
        const ar: string[] = [];
        for (let i = 0; i < 12; i++) {
            ar.push(cs.localize.month(i));
        }
        return ar as [string, string, string, string, string, string, string, string, string, string, string, string];
    },
    formatDate(_: Date, __?: string | string[], ___?: string): string {
        return "";
    },
    parseDate(str: string, _?: string, __?: string): Date {
        return stringInputParseDate(str) as Date;
    },
};
